<template>
	<div class="tittle">
		<div class="iconfont" @click="goback">&#xe618;</div>
		<span>{{lotname}}</span>
	</div>
</template>

<script>
	import { ref,inject } from 'vue'
	import { useRouter } from 'vue-router'
	export default{
		name: 'Header',
		setup(){
			const { lotid } = inject('lottery')
			const nameobj = {'001':'双色球','113':'大乐透','002':'福彩3D','108':'排列三','109':'排列五','110':'七星彩','003':'七乐彩','300':'胜负任九','201':'竞彩足球','200':'竞彩篮球','400':'北京单场','302':'半全场','303':'进球彩'}
			const router = useRouter()
			let lotname = ref(nameobj[lotid])
			const goback = ()=>{
				// router.push({name:'Hall'})
				//router.back()
				window.history.go(-1)
			}
			return { lotname,goback }
		}
	}
</script>

<style scoped="scoped">
	.tittle {
		width:100%;
	    position: relative;
	    background: #FFFFFF;
	    box-shadow: 0px .02rem .03rem 0px rgba(0,0,0,0.09);
	    margin-bottom: .02rem;
	}
	.tittle .iconfont{
	    width: .44rem;
	    height: .44rem;
	    position: absolute;
	    left: 0;
	    top: 0;
		font-size:.2rem;
		text-align: center;
		line-height: .44rem;
	}
	.tittle span {
	    display: block;
	    width: 100%;
	    height: .45rem;
	    font-size: .18rem;
	    line-height: .45rem;
	    text-align: center;
	    color: #333;
	}
</style>
